import type { ConfidenceCheckerSummaryResponse } from "@nlc/shared-types";

import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { getConfidenceCheckerSummary } from "../api/confidenceCheckerSummary.api";

export function useConfidenceCheckerSummaryQuery(
  requestId: number,
): UseQueryResult<ConfidenceCheckerSummaryResponse> {
  return useQuery({
    enabled: Boolean(requestId && !Number.isNaN(requestId)),
    queryFn: () => getConfidenceCheckerSummary(requestId),
    queryKey: ["confidence-checker-summary", requestId],
  });
}
